import { render, staticRenderFns } from "./PaymentsList.vue?vue&type=template&id=4398efa3&"
import script from "./PaymentsList.vue?vue&type=script&lang=js&"
export * from "./PaymentsList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsList.vue?vue&type=style&index=0&id=4398efa3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports